import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

const items = document.querySelectorAll(".video-player");
// If the element is an image, Gutenberg by default assigns a class to the "figure" element.
// We need to change this behavior by removing the class from the "figure" element and assigning it to the link instead.
items.forEach((element) => {
  if (element.tagName == "FIGURE") {
    element.classList.remove("video-player");
    const link = element.querySelector("a");
    link.classList.add("video-player");
  }
});

Fancybox.bind(".video-player");

const elements = document.querySelectorAll(".video-player");
if (elements) {
  elements.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      Fancybox.show([
        {
          src: item.href,
          type: "video",
          video: {
            tpl: `<video class="fancybox-video" controls controlsList="nodownload">
                    <source src="${item.href}" type="{{format}}" />
                    Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!
                  </video>`,
          },
        },
      ]);
    });
  });
}

Fancybox.bind('[data-fancybox="simple-slider"]', {
  Image: {
    zoom: false,
  },
});
